export function registerBasicDiagnostics(monaco, editor, language) {
  const model = editor.getModel();
  if (!model) return () => {};

  const checkCode = () => {
    const code = model.getValue();
    const markers = [];

    if (language === 'c' || language === 'cpp' || language === 'java') {
      const lines = code.split('\n');
      lines.forEach((line, index) => {
        const trimmed = line.trim();
        if (!trimmed || trimmed.startsWith('//') || trimmed.startsWith('/*') || trimmed.startsWith('*')) {
          return;
        }
        if (
          /^(if|else|for|while|switch|case|default|#include|#define|using|namespace|public|private|protected|class|struct|enum)\b/.test(
            trimmed,
          )
        ) {
          return;
        }
        if (/[{}\[\](){};]$/.test(trimmed)) return;
        if (/^\s*\/\//.test(line)) return;
        if (trimmed.endsWith('{') || trimmed.endsWith('}')) return;

        if (/^(int|char|float|double|void|return|break|continue)\b/.test(trimmed) && !trimmed.endsWith(';')) {
          markers.push({
            severity: monaco.MarkerSeverity.Error,
            message: 'Missing semicolon',
            startLineNumber: index + 1,
            startColumn: 1,
            endLineNumber: index + 1,
            endColumn: line.length + 1,
          });
        }
      });

      const openBraces = (code.match(/{/g) || []).length;
      const closeBraces = (code.match(/}/g) || []).length;
      if (openBraces > closeBraces) {
        markers.push({
          severity: monaco.MarkerSeverity.Error,
          message: 'Missing closing brace }',
          startLineNumber: lines.length,
          startColumn: 1,
          endLineNumber: lines.length,
          endColumn: lines[lines.length - 1].length + 1,
        });
      }
    }

    if (language === 'python') {
      const lines = code.split('\n');
      lines.forEach((line, index) => {
        if (line.trim().endsWith(':') && lines[index + 1]?.trim() === '') {
          markers.push({
            severity: monaco.MarkerSeverity.Warning,
            message: 'Expected indented block',
            startLineNumber: index + 2,
            startColumn: 1,
            endLineNumber: index + 2,
            endColumn: 2,
          });
        }
      });
    }

    monaco.editor.setModelMarkers(model, 'basic-lint', markers);
  };

  const disposable = model.onDidChangeContent(() => {
    window.clearTimeout(registerBasicDiagnostics._timer);
    registerBasicDiagnostics._timer = window.setTimeout(checkCode, 400);
  });

  checkCode();

  return () => {
    disposable.dispose();
    monaco.editor.setModelMarkers(model, 'basic-lint', []);
  };
}
